// Comparison limits, shared so the client tray and the server validation can
// never disagree about how many entities may be compared.
export const MIN_COMPARE = 2;
export const MAX_COMPARE = 4;
